'use strict'

const styleElement = document.createElement('dom-module')
styleElement.innerHTML = `<template>
  <custom-style>
    <style is="custom-style">
    paper-material, paper-card {
      box-shadow:  5px 5px 10px var(--paper-blue-grey-300), 0px 0px 10px var(--paper-blue-grey-200);
      border-radius: 6px;
    }
    
    paper-card {
    margin-bottom: 12px;
    }
    .width-100-percent {
      width: 100%;
    }
    .accent {
      color: var(--accent-color);
    }
    paper-button {
      color: var(--default-primary-color);
    }
    paper-button[disabled] {
      color: var(--light-primary-color);
    }
    </style>
    </custom-style>
  </template>`
styleElement.register('moskito-styles')
